import {
  FaDatabase,
  FaPython,
  FaReact,
  FaAngular,
  FaGithub,
  FaHtml5,
  FaCss3Alt,
  FaDocker,
} from 'react-icons/fa'
import {
  SiTypescript,
  SiJavascript,
  SiPytorch,
  SiScikitlearn,
  SiPandas,
  SiJira,
  SiGooglecloud,
  SiClaude,
  SiGooglegemini,
} from 'react-icons/si'
import './SkillsGrid.css'

const SkillsGrid = () => {
  const skills = [
    { name: 'Python', accent: '#3776AB', icon: <FaPython size={40} /> },
    {
      name: 'TypeScript',
      accent: '#3178C6',
      icon: <SiTypescript size={40} color="#3178C6" />,
    },
    {
      name: 'JavaScript',
      accent: '#F7DF1E',
      icon: (
        <SiJavascript
          size={40}
          color="#F7DF1E"
          style={{ backgroundColor: 'black' }}
        />
      ),
    },
    {
      name: 'HTML',
      accent: '#E34F26',
      icon: <FaHtml5 size={40} color="#E34F26" />,
    },
    {
      name: 'CSS',
      accent: '#1572B6',
      icon: <FaCss3Alt size={40} color="#1572B6" />,
    },
    {
      name: 'SQL',
      accent: '#336791',
      icon: <FaDatabase size={40} color="#336791" />,
    },
    {
      name: 'React',
      accent: '#61DAFB',
      icon: <FaReact size={40} color="#61DAFB" />,
    },
    {
      name: 'Angular',
      accent: '#DD0031',
      icon: <FaAngular size={40} color="#DD0031" />,
    },
    { name: 'Pandas', accent: '#150458', icon: <SiPandas size={40} /> },
    {
      name: 'Scikit-learn',
      accent: '#F7931E',
      icon: <SiScikitlearn size={40} color="#F7931E" />,
    },
    {
      name: 'PyTorch',
      accent: '#EE4C2C',
      icon: <SiPytorch size={40} color="#EE4C2C" />,
    },
    {
      name: 'Google Cloud',
      accent: '#4285F4',
      icon: <SiGooglecloud size={40} />,
    },
    { name: 'GitHub', accent: '#6E7681', icon: <FaGithub size={40} /> },
    {
      name: 'Jira',
      accent: '#0052CC',
      icon: <SiJira size={40} color="#0052CC" />,
    },
    {
      name: 'Docker',
      accent: '#2496ED',
      icon: <FaDocker size={40} color="#2496ED" />,
    },
    {
      name: 'Codex',
      accent: '#4D5DFF',
      icon: (
        <img
          src="codex-icon.png"
          alt=""
          className="skill-icon skill-icon--codex"
        />
      ),
    },
    {
      name: 'Claude',
      accent: '#D97757',
      icon: <SiClaude size={40} />,
    },
    {
      name: 'Gemini',
      accent: '#5B5CE2',
      icon: <SiGooglegemini size={40} />,
    },
  ]

  return (
    <div className="skills-grid">
      {skills.map((skill) => (
        <div
          key={skill.name}
          className="skill-card"
          style={{ '--skill-accent': skill.accent }}
        >
          {skill.icon}
          <span className="skill-label">{skill.name}</span>
        </div>
      ))}
    </div>
  )
}

export default SkillsGrid
